
var DOC=document.documentElement;DOC.classList.add('js');
function setAcc(h){DOC.style.setProperty('--acc',h)}
var prog=document.querySelector('.prog');
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.14});
document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
var hLid=document.getElementById('hLid'),hero=document.querySelector('.hero');
var seq=document.querySelector('.seq'),beats=document.querySelectorAll('.seq .beat'),seqLid=document.getElementById('seqLid');
var film=document.querySelector('.film'),track=document.querySelector('.film .track'),panelsEl=document.querySelectorAll('.panel'),countEl=document.querySelector('.film .count');
var N=panelsEl.length;
function frame(){
  var y=scrollY;
  if(hero){var hp=Math.min(1,Math.max(0,y/innerHeight));if(hLid){hLid.style.transform='translateY('+(hp*-50)+'px) scale('+(1+hp*0.22)+')'}}
  if(seq){var r=seq.getBoundingClientRect();var p=Math.min(1,Math.max(0,(-r.top)/(seq.offsetHeight-innerHeight)));
    var idx=Math.min(beats.length-1,Math.floor(p*beats.length));
    beats.forEach(function(b,i){b.classList.toggle('on',i===idx)});
    if(seqLid){seqLid.style.transform='rotate('+(p*36)+'deg) scale('+(1+Math.sin(p*Math.PI)*0.07)+')'}}
  if(film){var fr=film.getBoundingClientRect();var fp=Math.min(1,Math.max(0,(-fr.top)/(film.offsetHeight-innerHeight)));
    var maxX=(N-1)*innerWidth;track.style.transform='translateX('+(-fp*maxX)+'px)';
    var ai=Math.min(N-1,Math.round(fp*(N-1)));
    if(countEl)countEl.textContent='('+('0'+(ai+1)).slice(-2)+' / '+N+')';}
  prog.style.width=(y/(document.body.scrollHeight-innerHeight)*100)+'%';raf=0;
}
var raf=0;
addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(frame)},{passive:true});
addEventListener('resize',frame);frame();
